<div class="bg-white rounded-lg h-full w-full border flex flex-col"> 
    <div class="p-5 py-3 flex items-center justify-between border-b capitalize">
        <p class="text-sm font-semibold">top students</p>
        <select *ngIf="filter" class="select select-ghost select-xs" [(ngModel)]="selectedOption">
            <option value="video-content">Video Content</option>
            <option value="flashcard">Flashcards</option>
            <option value="all-tests">All Tests</option>
        </select>
    </div>

    <!-- Main scrollable container -->
    <div class="flex-1 overflow-hidden">
        <div class="overflow-y-auto h-full min-h-0">
            <!-- Messages -->
            @if (selectedOption == 'video-content') {
                <ul>
                    @for (i of messages; track $index) {
                        <li class="">
                            <a class="hover:bg-zinc-100 p-3 flex items-center">
                                <div class="flex gap-3 items-start w-full">
                                    <div class="flex gap-2 items-center">
                                        <div class="w-8"> 
                                            <span>
                                                {{$index + 1}}{{$index + 1 == 1 ? 'st' :$index + 1 == 2 ? 'nd' :$index + 1 == 3 ? 'rd' :'th'}}
                                            </span>
                                        </div>
                                        <div class="w-8 h-8">
                                            @if (i.sender_image) {
                                                <img class="w-full h-full rounded-full object-cover" src="{{i.sender_image}}" alt="">
                                        } @else {
                                            <span class="w-full h-full rounded-full bg-primary-600 text-white flex items-center justify-center">{{i.sender_name[0]}}</span>
                                        }
                                    </div>
                                    </div>
                                    <div class="flex-1">
                                        <!-- <small class="text-xs text-zinc-500">{{i.date | date:'short'}}</small> -->
                                        <!-- <p class="text-xs line-clamp-2">{{i.message}}</p> -->
                                        <p class="text-sm font-medium">{{i.sender_name}}</p>
                                        <div class="text-xs rounded  text-zinc-600 font-medium">{{i.class}}</div>
                                    </div>
                                    <!-- <div class="text-xs p-2 rounded bg-zinc-100 text-zinc-600 font-semibold">{{i.class}}</div> -->
                                     <p class="font-semibold">98.65%</p>
                                </div>
                            </a>
                        </li>
                    }
                </ul>
            }
            <!-- Messages -->
            <!-- Chats -->
            @else if (selectedOption == 'flashcard') {
                
            }
            <!-- Chats -->
              <!-- Messages -->
            @else if (selectedOption == 'all-tests') {
                
            }
            <!-- Messages -->
        </div>
    </div>
</div>
